module.exports = __webpack_public_path__ + "img/redcat.597bc48a.png";